"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeploymentList = exports.Compute = void 0;
const utils_1 = require("../../../utils");
exports.Compute = {
    _namespace_: "compute",
    async info() {
        const res = await this.call("compute.info");
        return getComputeInfo(res);
    },
    async deploy(param, { nonce } = { nonce: (0, utils_1.makeRandomBytes)(16) }) {
        const data = makeComputeDeployData(param);
        await this.call("compute.deploy", data, { nonce });
    },
    async close(param, { nonce } = { nonce: (0, utils_1.makeRandomBytes)(16) }) {
        const data = makeComputeCloseData(param);
        await this.call("compute.close", data, { nonce });
    },
    async list(param) {
        const data = makeComputeListData(param);
        const res = await this.call("compute.list", data);
        return getDeploymentList(res);
    },
};
function makeComputeDeployData(param) {
    const data = new Map();
    data.set(0, param.image);
    data.set(1, param.port);
    data.set(2, param.num_cpu);
    data.set(3, param.num_memory);
    data.set(4, param.memory_type);
    data.set(5, param.num_storage);
    data.set(6, param.storage_type);
    data.set(7, param.region);
    return data;
}
function makeComputeCloseData(param) {
    const data = new Map();
    data.set(0, param.dseq);
    return data;
}
function makeComputeListData(param) {
    const data = new Map();
    if (param.owner) {
        data.set(0, param.owner);
    }
    return data;
}
function getComputeInfo(message) {
    const data = message.getPayload();
    const result = {
        hash: Buffer.from(data.get(0)).toString("hex"),
    };
    return result;
}
function getDeploymentList(message) {
    const data = message.getPayload();
    const result = {
        deployments: data.get(0).map((item) => (Object.assign({ status: item.get(0), dseq: item.get(1), image: item.get(3) }, (item.get(2) && {
            meta: {
                provider: item.get(2).get(0),
                price: item.get(2).get(2),
                provider_info: Object.assign(Object.assign({}, (item.get(2).get(1).get(0) && {
                    host: item.get(2).get(1).get(0),
                })), { port: item.get(2).get(1).get(1), external_port: item.get(2).get(1).get(2), protocol: item.get(2).get(1).get(3) }),
            },
        })))),
    };
    return result;
}
exports.getDeploymentList = getDeploymentList;
